<template>
  <div class="login">
    <div class="content">
      <div class="tips">欢迎登陆商城</div>
      <div class="login-form">
        <div class="form-common flex-h" v-show="type == 0">
          <span>用户名</span>
          <input
            type="text"
            class="flex-1"
            placeholder="请输入登陆账号"
            v-model="userName"
            @keyup.enter="login"
          />
        </div>
        <div class="form-common flex-h" v-show="type == 0">
          <span>密&emsp;码</span>
          <input
            type="text"
            class="flex-1"
            placeholder="请输入登陆密码"
            v-model="password"
            @keyup.enter="login"
          />
        </div>
        <div class="form-common flex-h" v-show="type == 1">
          <span>手机号</span>
          <input
            type="tel"
            class="flex-1"
            placeholder="请输入手机号码"
            v-model="phone"
            @keyup.enter="login"
            style="padding-right: 100px"
          />
          <div class="phone-code-btn" @click.stop="showCode">
            {{ countDownNum }}
          </div>
        </div>
        <div class="form-common flex-h" v-show="type == 1">
          <span>验证码</span>
          <input
            type="tel"
            class="flex-1"
            placeholder="请输入短信验证码"
            v-model="smsNum"
            @keyup.enter="login"
          />
        </div>
        <div v-if="type == 0" @click="type = 1" class="change-btn">
          切换为手机+验证码登陆>>
        </div>
        <div v-else @click="type = 0" class="change-btn">
          切换为账号密码登陆>>
        </div>
        <div class="login-btn" @click="login">登陆</div>
        <div class="go-touris" @click="touristLogin" v-if="showTouris == 1">
          没有账号 ？先去逛一逛
        </div>
        <div class="no-discount" @click="goRegister">没有账号 ? 点击去注册</div>
        <div class="company">东莞市福欣电脑科技有限公司</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  storeBase,
  pcLogin,
  touristLogin,
  getCode,
  phoneLogin,
} from "@/api/api";
import verify from "@/api/tool";
export default {
  data() {
    return {
      userName: "",
      password: "",
      showTouris: 0, //实现展示游客登陆
      type: 0, //0是账号密码登陆1是手机验证码登陆
      phone: "", //手机号
      smsNum: "", //验证码
      countDownNum: "获取验证码",
      countNum: 60, //倒计时
      loading: false, //防止重复请求
      timer: null, //定时器
    };
  },
  mounted() {
    this.getStore();
  },
  methods: {
    //去注册
    goRegister() {
      this.$router.push({
        path: "/register",
      });
    },
    //获取短信验证码
    async showCode() {
      var that = this;
      var phone = that.phone;
      if (verify.verifyPhone(phone)) {
        this.$toast("请输入有效手机号");
        return;
      }
      if (that.loading) return;
      that.loading = true;
      var str = {
        phone,
      };
      var res = await getCode(str);
      that.loading = false;
      if (res.code == 200) {
        that.countDownNum = "已发送(" + this.countNum + "s)";
        that.countNumCode();
      } else {
        that.$toast(res.error);
      }
      console.log(res);
    },
    //倒计时
    countNumCode() {
      var that = this;
      that.timer = setInterval(() => {
        var countDownNum = that.countNum;
        countDownNum--;
        that.countDownNum = "已发送(" + countDownNum + "s)";
        that.countNum = countDownNum;
        if (countDownNum <= 0) {
          clearInterval(that.timer); // 移除定时器
          that.countDownNum = "重新获取";
          that.countNum = 60;
        }
      }, 1000);
    },
    //获取商家令牌和商家代号
    async getStore() {
      let str = {
        // storeCode: window.location.host,
        storeCode:  this.GLOBAL.isTest ? window.location.host : window.location.host,
        // storeCode:"www.yxpf888.com",
      };
      const res = await storeBase(str);
      console.log(res);
      if (res.code == 200) {
        sessionStorage.setItem("storeToken", res.data.token);
        sessionStorage.setItem("storeCode", res.data.storeCode);
        sessionStorage.setItem("storeBase", JSON.stringify(res.data));
        this.showTouris = res.data.qyTravelLogin;
      } else {
        this.$dialog
          .alert({
            message: res.error,
          })
          .then(() => {});
      }
    },
    //正常登陆
    async login() {
      var type = this.type;
      var str = {};
      if (type == 0) {
        str = {
          account: this.userName,
          sign: this.password,
        };
        if (str.account === "" || str.sign === "") {
          this.$toast.fail("账号密码不能为空");
          return;
        }
      } else {
        str = {
          phone: this.phone,
          smsNum: this.smsNum,
        };
        if (verify.verifyPhone(str.phone)) {
        this.$toast.fail("请输入有效手机号");
        return;
      }
      if (str.smsNum == "") {
        this.$toast.fail("请输入短信验证码");
        return;
      }
      }

      if (this.loading) return;
      this.loading = true;
      const res = type == 0 ? await pcLogin(str) : await phoneLogin(str);
      console.log(res);
      if (res.code == 200) {
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("uni", res.data.uni);
        sessionStorage.setItem("customer", res.data.name);
        if (this.$route.query.type == 2) {
          this.$router.go(-1);
        } else {
          this.$router.replace({
            path: "/home",
          });
        }
      } else {
        this.$toast(res.error);
        this.loading = false;
      }
    },
    //游客登录
    async touristLogin() {
      const res = await touristLogin();
      console.log(res);
      if (res.code == 200) {
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("uni", res.data.uni);
        sessionStorage.setItem("customer", res.data.name);
        sessionStorage.setItem("unionSelfSupport", res.data.unionSelfSupport);
        this.$router.replace({
          path: "/home",
        });
      } else {
        this.$dialog
          .alert({
            message: res.error,
          })
          .then(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  height: 100vh;
  width: 100vh;
  .content {
    // height: 500px;
    // font-family: Georgia, "Times New Roman", Times, serif;
    font-family: Source Han Sans CN;
    width: 300px;
    background-color: #fff;
    position: fixed;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    top: 100px;
    padding: 50px 30px;
    text-align: left;
    border-radius: 10px;
    .tips {
      font-size: 24px;
      color: #000;
      font-weight: bold;
      text-align: left;
    }
    .form-common {
      margin: 30px 0;
      position: relative;
      .phone-code-btn {
        position: absolute;
        right: 4px;
        cursor: pointer;
        background-color: #1989fa;
        border-radius: 5px;
        width: 80px;
        color: #fff;
        height: 28px;
        line-height: 28px;
        text-align: center;
      }
      span {
        margin-right: 10px;
        color: #000;
        font-size: 14px;
      }
      input {
        height: 36px;
        border: none;
        border: 1px solid #000;
        border-radius: 5px;
        padding: 0 10px;
        &::placeholder {
          font-size: 14px;
        }
      }
    }
    .change-btn {
      text-align: center;
      cursor: pointer;
      color: #666;
    }
    .login-btn {
      width: 100%;
      height: 34px;
      line-height: 34px;
      border-radius: 10px;
      background-color: #1989fa;
      color: #fff;
      letter-spacing: 10px;
      font-size: 14px;
      text-align: center;
      margin-top: 30px;
      cursor: pointer;
    }
    .no-discount {
      text-align: center;
      margin: 10px 0;
      cursor: pointer;
      &:hover {
        color: #ff0000;
      }
    }
    .go-touris {
      text-align: center;
      margin: 10px 0;
      color: #1989fa;
      cursor: pointer;
      &:hover {
        color: #ff0000;
      }
    }
    .company {
      color: #333;
      text-align: center;
      margin-top: 30px;
      font-size: 12px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/index.vue